import { createStore } from 'vuex'
import axios from 'axios';

import cats from './../assets/data/cats.json';

export default createStore({
	state: {
		content: null,
		map: null,
		categories: cats
	},
	mutations: {
		SAVE_CONTENT (state, data) {
			state.content = data.data;
		}, 

		SAVE_MAP (state, data) {
			// console.log("map: ", data);
			state.map = data;
		}, 

		UPDATE_CATS (state, data) {
			state.categories = data;
		}, 
	},
	getters: {
		articleItems: state => state.articles
	},
	actions: {
		loadContent ({commit, state}) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
							commit("SAVE_CONTENT", result.data);
							resolve();
					})
					.catch(error => {
							reject();
							throw new Error(`API ${error}`);
					});
			});
		}, 

		loadMap ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.BASE_URL + 'data/blokjes_ijsselmeer.geojson')
					.then(result => {
						commit("SAVE_MAP", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			});
		}, 

		updateCategories({commit, state}, cats) {
			commit("UPDATE_CATS", cats);
		} 
	},
	modules: {

	}
})
